import $ from 'jquery';
import { MQ } from '../tools/MQ.js';

export const init = () => {
	const ACTIVE_CLASS = 'nav-main__link--active';

	const $menuLinks = $('.js-menu-link'),
		$megaMenus = $('.js-menu-mega'),
		$menuList = $('.nav-main__list');

	$menuLinks.on('mouseenter', function (e) {
		if (MQ('lgDown')) {
			return;
		}

		// show only the selected mega menu
		$megaMenus.hide();
		$(this).next().show();

		$menuLinks.removeClass(ACTIVE_CLASS);
		$(this).addClass(ACTIVE_CLASS);
	});

	$menuList.on('mouseleave', function () {
		if (MQ('lgDown')) {
			return;
		}

		// hide all megamenus
		$megaMenus.hide();

		$menuLinks.removeClass(ACTIVE_CLASS);
	});
};
